module.exports = __webpack_public_path__ + "img/switch_banner_de.7d749276.png";